<div class="sponsor-list component-viewer">
  <mat-card>
    <mat-card-header class="list-header">
      <mat-card-title>Sponsors</mat-card-title>
      <button
        *ngIf="selectedIteration"
        mat-flat-button
        color="primary"
        type="button"
        class="list-header__action"
        [routerLink]="['/outing-management/administration/sponsor', 'create', searchKey]"
      >
        <mat-icon>add</mat-icon>
        Add sponsor
      </button>
    </mat-card-header>

    <section
      *ngIf="selectedIteration && !isLoading"
      class="summary"
      aria-label="Sponsor summary for this outing iteration"
    >
      <div class="summary-grid">
        <div class="summary-item">
          <span class="summary-label">Total sponsorship</span>
          <span class="summary-value">{{ summary.totalAmount | currency }}</span>
        </div>
        <div class="summary-item">
          <span class="summary-label">Amount paid</span>
          <span class="summary-value">{{ summary.amountPaid | currency }}</span>
        </div>
        <div class="summary-item">
          <span class="summary-label">Amount unpaid</span>
          <span class="summary-value">{{ summary.amountUnpaid | currency }}</span>
        </div>
      </div>
    </section>

    <mat-card-content>
      <gt-table
        *ngIf="true"
        [loading]="isLoading"
        [defaultPageSize]="10"
        [updateFilterEvent]="updateFilterEvent"
        [filter]="filter"
        [data]="sponsors"
        (filterChanged)="getSponsors()"
        (filterReset)="resetFilter()"
      >
      </gt-table>
      <mat-progress-bar mode="indeterminate" *ngIf="isLoading" />
      <table mat-table [dataSource]="sponsors" matSort (matSortChange)="sortData($event)">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="name">Name</th>
          <td mat-cell *matCellDef="let sponsor">
            <a [routerLink]="['../sponsor/details/', sponsor.id]">{{ sponsor.name }}</a>
          </td>
        </ng-container>
        <ng-container matColumnDef="company">
          <th mat-header-cell *matHeaderCellDef>Company</th>
          <td mat-cell *matCellDef="let sponsor">{{ sponsor.company }}</td>
        </ng-container>
        <ng-container matColumnDef="requestReceipe">
          <th mat-header-cell *matHeaderCellDef>Request Receipe</th>
          <td mat-cell *matCellDef="let sponsor"><yes-no [value]="sponsor.type"></yes-no></td>
        </ng-container>
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Short Name</th>
          <td mat-cell *matCellDef="let sponsor">
            <ng-container *ngIf="sponsor.type == 1">Hole Sponsor</ng-container>
            <ng-container *ngIf="sponsor.type == 2">Cart Sponsor</ng-container>
            <ng-container *ngIf="sponsor.type == 3">Donation</ng-container>
            <ng-container *ngIf="sponsor.type == 4">Team</ng-container>
            <ng-container *ngIf="sponsor.type == 5">Other</ng-container>
          </td>
        </ng-container>
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>Amount</th>
          <td mat-cell *matCellDef="let sponsor">{{ sponsor.amount | currency }}</td>
        </ng-container>
        <ng-container matColumnDef="hasPaid">
          <th mat-header-cell *matHeaderCellDef>Has Paid</th>
          <td mat-cell *matCellDef="let sponsor">
            <true-false [value]="sponsor.hasPaid" [trueText]="'Yes'" [trueMatIcon]="'paid'" [falseText]="'No'" [falseMatIcon]="'error_outline'"></true-false>
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let sponsor">
            <a mat-stroked-button *ngIf="canEditOrDelete()" [routerLink]="['../sponsor/edit/', sponsor.id]">
              Edit <mat-icon>edit</mat-icon>
            </a>
            <button mat-stroked-button class="warning" *ngIf="canEditOrDelete()" (click)="delete(sponsor)">
              Delete <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </mat-card-content>
  </mat-card>
</div>
